import { useDropzone } from "react-dropzone";
import React, { useCallback, useEffect, useState } from "react";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { Grid } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import FolderZipOutlinedIcon from "@mui/icons-material/FolderZipOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";

export default function DropzonePluseCmp(props: any) {
  const [files, setFiles] = useState([]);
  const onDrop = useCallback((acceptedFiles: any) => {
    setFiles(
      acceptedFiles.map((file: Blob | MediaSource) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      )
    );
  }, []);
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/jpeg": [],
      "image/png": [],
      "image/bmp": [],
      "image/tiff": [],
      "image/gif": [],
      "application/pdf": [],
      "application/vnd.ms-excel": [],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
    },
    onDrop: onDrop,
    noClick: props.errors,
    multiple: false,
  });

  useEffect(() => {
    if (files.length > 0) {
      props.onFileChoosed(acceptedFiles);
    }
  }, [files]);

  return (
    <>
      <Grid
        container
        style={{
          paddingLeft: "10vh !important",
          paddingBottom: "5vh ",
          paddingRight: props.paddingRight,
        }}
      >
        <Grid
          item
          xs={props.size}
          className="dropzoneUploadImage"
          style={{ minHeight: "16vh" }}
        >
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            <div
              className="uploadImage classCenter"
              style={{ paddingTop: "5vh" }}
            >
              <AddCircleIcon
                style={{ color: "#1565C0", width: "30px", height: "30px" }}
                className="classCenter"
              />
              <span
                style={{
                  color: "#1565C0",
                  fontSize: "14px",
                  whiteSpace: "nowrap",
                }}
                className="classCenter"
              >
                {props.picName}
              </span>
            </div>
          </div>
        </Grid>
      </Grid>
    </>
  );
}
